// The values of this constants are replaced during CI build (see .gitlab-ci.yml)

export const S3_BUCKET = "@@S3_BUCKET@@";
export const JSON_LIST_PATH = "@@JSON_LIST_PATH@@";
export const ASSETS_PATH = "@@ASSETS_PATH@@";


// WEBPACK FOOTER //
// ./js/CIConstants.js